import { useState } from "react";
import StepperMUI from "../../../common/components/Stepper/Stepper";
import SelectPlatformsStep from "./SelectPlatformsStep";
import ConfirmationBeforePublish from "./ConfirmationBeforePublishStep";

export default function PublishSameVersionOnNewPlatformsWrapper() {
  const [step, setStep] = useState(0);
  const incrementStep = () => setStep(step + 1);
  const decrementStep = () => setStep(step - 1);

  const renderStep = (step: number) => {
    switch (step) {
      case 0:
      default:
        return <SelectPlatformsStep incrementStep={incrementStep} isTheOnlyPublishingStep />;
      case 1:
        return <ConfirmationBeforePublish decrementStep={decrementStep} />;
    }
  };

  return (
    <div className="flex flex-col align-center items-center h-full w-full publishSameVersionOnNewPlatforms">
      <StepperMUI mode="publishSameVersionOnNewPlatforms" step={step} />
      {renderStep(step)}
    </div>
  );
}
